import { NgClass } from '@angular/common'
import { AfterViewInit, Component, ElementRef, OnInit, viewChildren, ViewEncapsulation } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { InterviewState, Question } from '@bequeathed/ngx-services'
import { LoggerService } from '@bequeathed/ngx-app-core'
import { FormControlPipe } from '@bequeathed/ngx-utils'
import { BaseSelectionControl } from '../base-selection-control/base-selection-control.component'

const LOG: LoggerService = LoggerService.get('RadioButtonControl')

/**
 * Control to display radio buttons
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'radio-button-control',
    templateUrl: './radio-button-control.component.html',
    styleUrls: [
        './radio-button-control.component.sass',
        '../../base-form/base-form.component.sass',
        '../base-input-control/base-input-control.component.sass'
    ],
    standalone: true,
    imports: [
        // Bequeathed
        FormControlPipe,
        // Angular
        NgClass,
        ReactiveFormsModule
    ],
    encapsulation: ViewEncapsulation.None
})
export class RadioButtonControl extends BaseSelectionControl implements OnInit, AfterViewInit {

    radioButtons = viewChildren<ElementRef>('input')

    override ngOnInit(): void {
        LOG.debug('init', 'Creating RADIO control')

        this.inputClass = ''

        super.ngOnInit()

        if (this.editingResponse) {
            this.setPreviousResponse()
        }

        // try to convert plain value to unique so that radio buttons works
        if (!!this.control.value && !(this.control.value as string).startsWith(this.question.id!)) {
            this.control.patchValue(`${this.question.id}###${this.control.value}`)
            this.control.updateValueAndValidity()
        }
    }

    ngAfterViewInit() {
        if (this.editingResponse) {
            this.radioButtons().forEach(radioButton => {
                //const valueArray = radioButton.nativeElement.value.split('#').pop()
                const radioOption = radioButton.nativeElement.value.split('#').pop()
                if (radioOption === this.question.userResponse) {
                    radioButton.nativeElement.checked = true
                    return
                }
            })
        }
    }

    isHoriz(): boolean {
        return this.inputClass === 'options-wrapper-horizontal'
    }

    getControlValue(): string {
        return !!this.control && !!this.control.value ? this.control.value.split('###')[1] : null
    }

    selectOption(key: string): void {
        super.setModelValue(`${this.question.id}###${key}`)
        this.control.updateValueAndValidity()
    }

    nameAttr(): string {
        return `${this.question.id}${(this.groupIndex || '')}`
    }

    override applyValue(state: InterviewState | Question): void {
        if (state instanceof InterviewState) {
            state.currentQuestion!.userResponse = this.getControlValue()

        } else if (!this.standalone) {
            state.userResponse = this.getControlValue()
        }
    }
}
